import {
  DEVICES_AVAILABLE_FETCH_STARTED,
  DEVICES_AVAILABLE_FETCH_SUCCEEDED,
  DEVICES_AVAILABLE_FETCH_FAILED,
  DEVICES_AVAILABLE_CLEAR
} from '#action/types';
import { requestStatuses as statuses } from '#helper';

const defaultState = {
  status: statuses.idle,
  devicesAvailable: [],
  error: null
};

export default (state = defaultState, action) => {
  switch (action.type) {
    case DEVICES_AVAILABLE_FETCH_STARTED:
      return { ...state, status: statuses.loading, error: null };
    case DEVICES_AVAILABLE_FETCH_SUCCEEDED:
      return {
        ...state,
        status: statuses.succeeded,
        devicesAvailable: action.payload
      };
    case DEVICES_AVAILABLE_FETCH_FAILED:
      return { ...state, status: statuses.failed, devicesAvailable: [], error: action.error };
    case DEVICES_AVAILABLE_CLEAR:
      return defaultState;
    default:
      return state;
  }
};
